import React from "react";

/**
 * Scitus.ai logo recreated as inline SVG.
 * Cube-from-above mark: teal top diamond + dark navy/white side panels.
 * Used in two variants: "full" (mark + wordmark) and "mark" only.
 */
export const ScitusLogo = ({
    variant = "full",
    height = 30,
    showDot = true,
}) => {
    const markSize = height;
    return (
        <span
            className="scitus-logo"
            data-testid="scitus-logo"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                color: "#e6edf3",
                lineHeight: 1,
            }}
        >
            <svg
                width={markSize}
                height={markSize}
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-label="Scitus.ai mark"
            >
                {/* Top diamond — teal */}
                <path
                    d="M32 6 L56 20 L32 34 L8 20 Z"
                    fill="#00b4d8"
                />
                {/* Left panel — navy */}
                <path
                    d="M8 20 L32 34 L32 58 L8 44 Z"
                    fill="#0b1a2a"
                    stroke="#e6edf3"
                    strokeWidth="1.2"
                />
                {/* Right panel — navy */}
                <path
                    d="M56 20 L32 34 L32 58 L56 44 Z"
                    fill="#0b1a2a"
                    stroke="#e6edf3"
                    strokeWidth="1.2"
                />
                {/* Inner white V — the open-cube negative space */}
                <path
                    d="M20 27 L32 34 L32 48 L20 41 Z"
                    fill="#ffffff"
                />
                <path
                    d="M44 27 L32 34 L32 48 L44 41 Z"
                    fill="#ffffff"
                    fillOpacity="0.85"
                />
            </svg>

            {variant === "full" && (
                <span
                    style={{
                        fontFamily: "'Cabinet Grotesk', system-ui, sans-serif",
                        fontWeight: 800,
                        fontSize: height * 0.7,
                        letterSpacing: "-0.01em",
                    }}
                >
                    Scitus
                    {showDot && (
                        <span style={{ color: "#00b4d8" }}>.ai</span>
                    )}
                </span>
            )}
        </span>
    );
};

export default ScitusLogo;
